<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">用户注册</span>
      </v-card-title>
      <v-card-text>
        <h3>处理Point</h3>
        <ol>
          <li></li>
        </ol>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      username: null,
      password: null
    }
  }
}
</script>
<style scoped>
.login {
  position: absolute;
  top: 100px;
  right: 300px;
  width: 400px;
}
</style>
